import SwiperWrapper from '@/scripts/swiper-wrapper.js'

const decode = str => decodeURIComponent(str).replace(/\+/g, ' ')

class CarouselSwiper extends HTMLElement {
  constructor () {
    super()
    const carousel = this.querySelector(':scope > .swiper')
    const options = this.getAttribute('data-options')
    const checkCarousel = this.dataset && this.dataset.checkCarousel ? this.dataset.checkCarousel : false
    let is_carousel = true
    const optionsParse = JSON.parse(decode(options))

    if (checkCarousel && checkCarousel === "true") {
      const breakpoints = optionsParse && optionsParse.breakpoints ? optionsParse.breakpoints : []
      const windowInnerWidth = window.innerWidth
      let slidesPerView = 0
      const swiperWrapperEl = this.querySelector('.js-swiper-wrapper')
      const countChildEl = swiperWrapperEl && swiperWrapperEl.children ? swiperWrapperEl.children.length : 0
      Object.keys(breakpoints).forEach(breakpoint => {
        if (breakpoint <= windowInnerWidth) {
          slidesPerView = Math.floor(parseInt(breakpoints[breakpoint].slidesPerView))
        }
      })

      if (countChildEl <= slidesPerView) {
        is_carousel = false
      }
    }

    if (carousel && options && is_carousel) {
      new SwiperWrapper(carousel, JSON.parse(decode(options)))
    }
  }
}

customElements.define('carousel-swiper', CarouselSwiper)
